import React, { useRef, useState } from 'react'
import { addMonths } from 'date-fns'
import { Box } from '@chakra-ui/react'
import { FaCircleArrowLeft } from 'react-icons/fa6'

import {
    eqStringFilter,
    lteFloatFilter,
    gteFloatFilter,
    inStringArrFilter,
} from '~utils/query-helpers'
import {
    AppointmentStatus,
    ChatFieldsFragment,
    useQueryAppointmentsQuery,
} from '~graphql/generated/graphql'
import ChatInfoAccordionItem from '../info-accordion-item'
import AppointmentDetails from './appointment-details'
import InfoLoadingPlaceholder from '../info-loading-placeholder'
import AsyncWrapper from '~components/shared/wrappers/async-wrapper'

export default function ChatClientDetailsLastAppointment({
    chat,
}: {
    chat: ChatFieldsFragment
}) {
    const todayRef = useRef(new Date())
    const threeMonthsFromNowRef = useRef(addMonths(todayRef.current, -3))
    const { clinic, client } = chat

    const [isOpen, setIsOpen] = useState(false)

    const { data, loading } = useQueryAppointmentsQuery({
        variables: {
            where: [
                eqStringFilter('clinic', clinic.id),
                eqStringFilter('client', client.id),
                inStringArrFilter('status', [
                    AppointmentStatus.Completed,
                    AppointmentStatus.Cancelled,
                    AppointmentStatus.NoShow,
                ]),
                lteFloatFilter('start_time', todayRef.current.getTime()),
            ],
            page: 0,
            pageSize: 1,
            orderBy: {
                column: 'start_time',
                isAscending: false,
            },
        },
        skip: !clinic || !client || !isOpen,
    })

    const appointment = data?.queryAppointments?.at(0)

    return (
        <ChatInfoAccordionItem
            icon={FaCircleArrowLeft}
            title="Last Appointment"
            isOpenState={isOpen}
            setIsOpenState={setIsOpen}
        >
            <Box px={6} pt={2} pb={3}>
                <AsyncWrapper
                    loading={loading}
                    loadingComponent={<InfoLoadingPlaceholder />}
                >
                    <AppointmentDetails appointment={appointment} />
                </AsyncWrapper>
            </Box>
        </ChatInfoAccordionItem>
    )
}
